import { Controller } from "stimulus";

function selectText(element: Element) {
  const selection = window.getSelection();
  if (selection) {
    if (selection.type !== "Range") {
      const range = document.createRange();
      range.selectNodeContents(element);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }
}

export default class extends Controller {
  declare textTarget: Element;

  static get targets() {
    return ["text"];
  }

  public select() {
    selectText(this.textTarget);
  }
}
